import tw from 'tailwind-styled-components'
import {State} from './types'

export const TwIconButtonNew = tw.div<{
  $disabled?: boolean
  $forcedState?: State
  $error?: boolean
}>`
  w-16
  h-16
  inline-flex
  items-center
  justify-center
  ${p => {
    const cx: string[] = []
    if (p.$disabled) {
      cx.push('text-icon-disabled cursor-default')
    } else {
      cx.push('cursor-pointer')

      if (p.$forcedState === 'default') {
        cx.push(!p.$error ? 'text-icon-secondary' : 'text-error')
      } else if (p.$forcedState === 'hover') {
        cx.push(!p.$error ? 'text-action-hover' : 'text-error-l20')
      } else if (p.$forcedState === 'active') {
        cx.push(!p.$error ? 'text-action-pressed' : 'text-error-d20')
      } else {
        if (p.$error) {
          cx.push('text-error', 'hover:text-error-l20', 'active:text-error-d20')
        } else {
          cx.push(
            'text-icon-secondary',
            'hover:text-action-hover',
            'active:text-action-pressed'
          )
        }
      }
    }
    return cx.join(' ')
  }}
`
